"use strict";exports.e=(e="",o="")=>e?.toLowerCase()===o?.toLowerCase();